export default "__VITE_ASSET__Bb6Ccrsi__"